import {Dictionary} from "../models/Settings";
import store from "../store";

export const findStateColor = (state) => {
    const {settings: {dictionaries}} = store.getState()
    const colorDictionary = dictionaries['contract_state_color'] || []
    const color = colorDictionary.find(({value}: Dictionary) => value === state) || {text: ''}
    return color.text
}